import React, { useEffect, useState } from "react";
import { USER_URL } from "../../constant/api";
import { BsBoxSeam } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function SellerOfferAdd() {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [bannerPackages, setBannerPackages] = useState([]);
  const [selectedBannerPackage, setSelectedBannerPackage] = useState(null);
  const [bannerPackagesLoading, setBannerPackagesLoading] = useState(true);

  const [offerData, setOfferData] = useState({
    title: "",
    start_date: "",
    end_date: "",
    banner_image: null,
    offer_products: [],
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(true); // Loading state
  const fetchAdminBannerPackages = async () => {
    try {
      const response = await USER_URL.get(
        `/products/seller/packages/?promotion_type=SpecialOffer`,
      );
      console.log("Banner Packages Response:", response.data);
      setBannerPackages(response.data.Data);
      setBannerPackagesLoading(false);
    } catch (error) {
      console.error("Error fetching banner packages:", error.message || error);
      toast.error("Failed to fetch banner packages!");
    }
  };
  // Fetch products on component load
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await USER_URL.get(`/products/seller/`);
        if (response.data?.Data) {
          setProducts(response.data.Data);
        }
        console.log(response.data.Data);
      } catch (error) {
        console.error("Error fetching products:", error.message || error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchAdminBannerPackages(); // Fetch banner packages
    fetchProducts();
  }, []);

  // Handle form input change for offer data
  const handleOfferChange = (e) => {
    const { name, value } = e.target;
    setOfferData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle product selection and discount
  const handleProductSelect = (productId, discount = null) => {
    const updatedProducts = [...selectedProducts];
    const productIndex = updatedProducts.findIndex(
      (p) => p.product === productId,
    );

    if (productIndex === -1 && discount !== null) {
      // Add the product with the provided discount if not already added
      updatedProducts.push({
        product: productId,
        special_discount_percentage: discount,
      });
    } else if (productIndex === -1) {
      // Set the default discount (5) when adding the product
      updatedProducts.push({
        product: productId,
        special_discount_percentage: 5,
      });
    } else if (productIndex !== -1 && !discount) {
      // Remove the product if discount is empty
      updatedProducts.splice(productIndex, 1);
    } else {
      // Update the discount if the product already exists in the list
      updatedProducts[productIndex] = {
        product: productId,
        special_discount_percentage: discount,
      };
    }

    setSelectedProducts(updatedProducts);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) {
      return; // Prevent form submission if already submitting
    }

    // Validate required fields
    if (!selectedBannerPackage) {
      toast.warn("Please select a banner package.");
      return;
    }
    if (!offerData.title) {
      toast.error("Please enter the offer title.");
      return;
    }
    if (!offerData.banner_image) {
      toast.error("Please upload a banner image.");
      return;
    }
    if (!offerData.start_date) {
      toast.error("Please select a start date.");
      return;
    }
    // if (!offerData.end_date) {
    //   toast.error("Please select an end date.");
    //   return;
    // }
    // if (offerData.end_date <= offerData.start_date) {
    //   toast.error("End date must be greater than the start date.");
    //   return;
    // }
    if (selectedProducts.length === 0) {
      toast.error("Please select at least one product for the offer.");
      return;
    }

    // Proceed with form submission if validation passes
    setIsSubmitting(true);
    const formData = new FormData();

    // Append basic fields
    formData.append("title", offerData.title);
    formData.append("banner", offerData.banner_image);
    formData.append("start_date", offerData.start_date);
    // formData.append("end_date", offerData.end_date);
    formData.append("package", selectedBannerPackage.id);

    // Append each product dynamically
    selectedProducts.forEach((p, index) => {
      formData.append(`offer_products[${index}]product`, p.product); // Assuming p.product is the product ID
      formData.append(
        `offer_products[${index}]special_discount_percentage`,
        p.special_discount_percentage,
      ); // Assuming p.special_discount_percentage holds the discount
    });

    // Debugging: Log form data content
    console.log("Form Data being sent:", formData);

    try {
      const response = await USER_URL.post(
        `/products/seller/special-offer/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      toast.success("Offer created successfully!");
      console.log("Response Data:", response.data);

      // Reset all state values
      setOfferData({
        title: "",
        start_date: "",
        end_date: "",
        banner_image: null,
        offer_products: [],
      });
      setSelectedProducts([]);
      navigate("/seller/offer_brand/Offer");
    } catch (error) {
      // Log full error response for debugging
      console.error(
        "Error creating offer:",
        error.response?.data || error.message || error,
      );
      toast.error("Failed to create offer. Please try again.");
    } finally {
      setIsSubmitting(false); // Reset isSubmitting to false after submission completes
    }
  };

  return (
    <div>
      <div className="mb-5 mt-5">
        <h2 className="mb-4 text-center text-3xl font-medium text-brand-primary">
          Pick Your Banner Package
        </h2>
        {bannerPackagesLoading ? (
          <div>Loading...</div>
        ) : (
          <div className="flex w-full flex-wrap items-center justify-around gap-2">
            {bannerPackages.map((item) => (
              <div
                key={item.id}
                className={`flex w-full cursor-pointer flex-col items-center justify-center rounded-lg border-2 p-4 text-center shadow-md transition duration-300 ease-in-out hover:shadow-lg md:w-[300px] ${
                  selectedBannerPackage?.id === item.id
                    ? "border-green-600 bg-green-50"
                    : "border-gray-300 bg-white"
                }`}
                onClick={() => setSelectedBannerPackage(item)}
              >
                <div>
                  <h3 className="text-lg font-semibold">{item.name}</h3>
                  <p className="text-sm text-gray-600">Period: {item.period}</p>
                  <p className="text-sm text-gray-600">
                    Duration: {item.duration_days} day(s)
                  </p>
                  <p className="text-sm text-gray-600">Price: ₹{item.price}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="mt-10 rounded-lg border-2 bg-gray-50 p-2">
        <h2 className="mb-6 text-center text-3xl font-medium text-brand-primary">
          Create Offer
        </h2>

        {/* Offer Details Section */}
        <div className="mb-6 flex w-full flex-col gap-6 sm:flex-row">
          {/* Image input on the left side */}
          <div className="w-full sm:w-1/2">
            <label className="mb-2 block font-medium text-gray-700">
              Banner Image
            </label>
            <div className="rounded-md border">
              {offerData.banner_image ? (
                <div className="relative">
                  <img
                    src={URL.createObjectURL(offerData.banner_image)}
                    alt="Banner Preview"
                    className="mb-4 h-44 w-full rounded-md object-cover"
                  />
                  <button
                    type="button"
                    className="absolute right-2 top-2 rounded-full bg-red-500 px-2 py-1 text-xs text-white"
                    onClick={() =>
                      setOfferData({ ...offerData, banner_image: null })
                    }
                  >
                    Remove
                  </button>
                </div>
              ) : (
                <div className="mb-4 flex h-40 w-full items-center justify-center rounded-md bg-gray-100 text-gray-500">
                  No Image Selected
                </div>
              )}
              <input
                type="file"
                accept="image/*"
                onChange={(e) => {
                  const file = e.target.files[0];
                  setOfferData({ ...offerData, banner_image: file });
                }}
                className="mb-3 ml-3 text-sm text-gray-600 file:mr-4 file:rounded-full file:border-0 file:bg-blue-50 file:px-4 file:py-2 file:text-sm file:font-semibold file:text-blue-700 hover:file:bg-blue-100"
              />
            </div>
          </div>

          {/* Other inputs (offer title, start date, and end date) on the right side */}
          <div className="flex w-full flex-col gap-6 sm:w-1/2">
            <div className="w-full">
              <label className="mb-2 block font-medium text-gray-700">
                Offer Title
              </label>
              <input
                type="text"
                name="title"
                value={offerData.title}
                onChange={handleOfferChange}
                className="mb-3 w-full rounded border p-2"
                placeholder="Enter offer title"
              />
            </div>

            <div className="w-full">
              <label className="mb-2 block font-medium text-gray-700">
                Start Date
              </label>
              <input
                type="date"
                name="start_date"
                value={offerData.start_date}
                onChange={handleOfferChange}
                className="mb-3 w-full rounded border p-2"
              />
            </div>

            {/* <div className="w-full">
              <label className="text-gray-700 font-medium mb-2 block">End Date</label>
              <input
                type="date"
                name="end_date"
                value={offerData.end_date}
                onChange={handleOfferChange}
                className="w-full border p-2 rounded"
              />
            </div> */}
            <div className="flex gap-3">
              <label className="mb-2 font-medium text-gray-700">Period :</label>
              <p>{selectedBannerPackage?.period}</p>
            </div>
            <div className="flex gap-3">
              <label className="mb-2 font-medium text-gray-700">
                Duration :
              </label>
              {selectedBannerPackage ? (
                <p>{selectedBannerPackage?.duration_days} days</p>
              ) : (
                <p>0 days</p>
              )}
            </div>
            {/* Submit Button */}
            <div className="w-full">
              <button
                onClick={handleSubmit}
                // disabled={isSubmitting || !offerData.title || !offerData.start_date || !offerData.end_date || selectedProducts.length === 0}
                className={`mt-6 w-full rounded bg-green-600 px-6 py-3 text-white hover:bg-green-700 ${isSubmitting ? "cursor-not-allowed opacity-50" : ""}`}
              >
                {isSubmitting ? "Submitting..." : "Submit Offer"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Products Table Section */}
      <div className="mb-10 overflow-x-auto">
        {isLoading ? (
          <div className="flex h-40 items-center justify-center">
            <div className="spinner-border inline-block h-8 w-8 animate-spin rounded-full border-4 text-brand-primary"></div>
            <p className="ml-2">Loading products...</p>
          </div>
        ) : products.length === 0 ? (
          <div className="mt-10 text-center">
            <BsBoxSeam className="mx-auto mb-4 text-6xl text-gray-400" />
            <p className="text-lg text-gray-600">No products available</p>
          </div>
        ) : (
          <>
            {/* Table Header */}
            <div className="mt-10 w-full space-y-4">
              <div className="grid min-w-[800px] grid-cols-[4rem,2fr,1.5fr,1.5fr,1fr,2fr,1fr,1fr] font-medium text-brand-button-green-bg">
                <div className="text-center">Item No</div>
                <div className="text-center">Product Name</div>
                <div className="text-center">Product Code</div>
                <div className="text-center">Offer</div>
                <div className="text-center">Stock</div>
                <div className="text-center">New Discount</div>
                <div className="text-center">Add Offer</div>
                {/* <div className="text-center">View</div> */}
              </div>
            </div>

            {/* Table Body */}
            {products.map((product, index) => (
              <div
                key={product.id}
                className="grid min-w-[800px] grid-cols-[4rem,2fr,1.5fr,1.5fr,1fr,2fr,1fr,1fr] items-center gap-2 py-2 text-[#2F2E41]"
              >
                {/* Item Number */}
                <div className="line-clamp-1 rounded-xl border p-2 text-center hover:line-clamp-none">
                  {index + 1}
                </div>

                {/* Product Name */}
                <div className="line-clamp-1 rounded-xl border p-2 text-center hover:line-clamp-none">
                  {product.name}
                </div>

                {/* Product Code */}
                <div className="line-clamp-1 rounded-xl border p-2 text-center hover:line-clamp-none">
                  {product.product_code}
                </div>

                {/* Offer */}
                <div className="line-clamp-1 rounded-xl border p-2 text-center hover:line-clamp-none">
                  {product.offer_percent
                    ? `${product.offer_percent}%`
                    : "No Offer"}
                </div>

                {/* Stock */}
                <div className="line-clamp-1 rounded-xl border p-2 text-center hover:line-clamp-none">
                  {product.stock}
                </div>

                {/* New Discount Input */}
                <input
                  type="number"
                  value={
                    selectedProducts.find((item) => item.product === product.id)
                      ?.special_discount_percentage || ""
                  }
                  onChange={(e) =>
                    handleProductSelect(product.id, e.target.value)
                  }
                  className="rounded-xl border p-2 text-center"
                />

                {/* Add/Remove Offer Button */}
                <div className="text-center">
                  <div
                    onClick={() => handleProductSelect(product.id)}
                    className={`cursor-pointer rounded-xl p-2 text-center transition-all duration-300 ${
                      selectedProducts.find(
                        (item) => item.product === product.id,
                      )
                        ? "border-red-500 bg-red-100 text-red-600 hover:bg-red-200"
                        : "border-blue-500 bg-blue-100 text-blue-600 hover:bg-blue-200"
                    }`}
                  >
                    {selectedProducts.find(
                      (item) => item.product === product.id,
                    )
                      ? "Remove"
                      : "Add"}
                  </div>
                </div>
                {/* <div className="border p-2 rounded-xl text-center hover:bg-brand-primary text-brand-text-light hover:text-white transition ease-in-out duration-400">
                  <Link to={`/seller/products/view/${product.id}`}>View</Link>
                </div> */}
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
}

export default SellerOfferAdd;
